import React, { memo, ChangeEvent } from 'react'
import { ISpotBiddingRule } from 'apps/spot-quote-control-panel/types/spotBiddingConfig'
import { TextInput } from 'components/atoms'

interface IReasonProps {
  value?: string
  onChange(value: RecursivePartial<ISpotBiddingRule>): void
  error?: string
}

export const Reason = memo<IReasonProps>(({ error, onChange, value: reason }) => {
  const label = 'Reason'
  const placeholder = 'Enter a reason behind this rule'

  const reasonHandler = ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
    onChange({
      reason: value,
    })
  }

  return (
    <div className='col-md-6 col-xs-4'>
      <TextInput
        label={label}
        placeholder={placeholder}
        id='modal-reason'
        dataTest='modal-reason'
        value={reason}
        onChange={reasonHandler}
        large
        validationMessage={error}
        invalid={!!error}
      />
    </div>
  )
})
